"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledAccordionItemTitle = exports.StyledAccordionItemContent = exports.StyledAccordionItem = exports.StyledAccordionContainer = exports.AccordionNavigation = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _utils = require("../lib/utils");

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;

var StyledAccordionContainer = _styledComponents["default"].div(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n  ", "\n"])), function (props) {
  return (0, _utils.isRTL)(props) && "text-align: right;";
});

exports.StyledAccordionContainer = StyledAccordionContainer;

var AccordionNavigation = _styledComponents["default"].div(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2["default"])([""])));

exports.AccordionNavigation = AccordionNavigation;

var StyledAccordionItem = _styledComponents["default"].div(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2["default"])(["\n  background-color: #fff;\n  box-shadow: ", ";\n  border-radius: ", ";\n  margin-bottom: 10px;\n"])), function (props) {
  return (0, _utils.getShadow)('1')(props);
}, function (props) {
  return (0, _utils.getBorderRadius)('tertiary')(props);
});

exports.StyledAccordionItem = StyledAccordionItem;

var StyledAccordionItemTitle = _styledComponents["default"].div(_templateObject4 || (_templateObject4 = (0, _taggedTemplateLiteral2["default"])(["\n  cursor: pointer;\n  ", "\n  user-select: none;\n  box-sizing: border-box;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 28px;\n  padding-bottom: 0px;\n  color: ", ";\n  ", "\n\n  ", "\n\n  ", "\n\n  span.eui-sub-title {\n    color: ", ";\n    font-size: 13px;\n    margin-left: 10px;\n    vertical-align: bottom;\n    font-weight: 300;\n  }\n"])), function (props) {
  return (0, _utils.getTypography)('h2')(props);
}, function (props) {
  return (0, _utils.getPalette)('text', 'c04')(props);
}, function (props) {
  return !props.isActive && "\n    padding-bottom: 28px;\n  ";
}, function (props) {
  return (0, _utils.isRTL)(props) && "flex-direction: row-reverse;";
}, function (props) {
  return (0, _utils.isRTL)(props) && "\n    .eui-accordion-title {\n      display: flex;\n      flex-direction: row-reverse;\n\n      span.eui-sub-title {\n        margin-right: 10px;\n      }\n    }\n  ";
}, function (props) {
  return (0, _utils.getPalette)('text', 'c04')(props);
});

exports.StyledAccordionItemTitle = StyledAccordionItemTitle;

var StyledAccordionItemContent = _styledComponents["default"].div(_templateObject5 || (_templateObject5 = (0, _taggedTemplateLiteral2["default"])(["\n  display: none;\n  ", "\n  color: ", ";\n  padding: 28px;\n\n  ", "\n"])), function (props) {
  return (0, _utils.getTypography)('body')(props);
}, function (props) {
  return (0, _utils.getPalette)('text', 'c04')(props);
}, function (props) {
  return props.active && "\n    display: block;\n  ";
});

exports.StyledAccordionItemContent = StyledAccordionItemContent;